export default __webpack_public_path__ + "static/media/user-icon-pink.f0555fc1.svg";